var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "emd-table-responsive" },
    [
      _c("Table", {
        attrs: {
          fields: _vm.tableFields,
          items: _vm.items,
          actions: _vm.actions,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }